/*
 * Copyright 2026 North Carolina State University
 */

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../../styles/ManageProgramData.css';
import AccountsReceivable from './AccountsReceivable';
import Invoicing from './Invoicing';
import ResourceInvoicing from './ResourceInvoicing';

const SECTIONS = ['accounts-receivable', 'invoicing', 'resource-invoicing'];

const Accounting = () => {
  const location = useLocation();
  // An invoice notification deep-links here as
  // /admin/accounting?section=invoicing&search=<project>&invoiceId=<id>&tab=<status>.
  // The section opens here; Invoicing/ResourceInvoicing read the rest.
  const sectionFromUrl = new URLSearchParams(location.search).get('section');
  const [activeSection, setActiveSection] = useState(
    SECTIONS.includes(sectionFromUrl) ? sectionFromUrl : 'accounts-receivable'
  );

  // Follow later deep links too — clicking a notification while already on this
  // screen changes the query string without remounting the component.
  useEffect(() => {
    if (SECTIONS.includes(sectionFromUrl)) setActiveSection(sectionFromUrl);
  }, [sectionFromUrl]);

  const renderSection = () => {
    switch (activeSection) {
      case 'accounts-receivable':
        return <AccountsReceivable />;
      case 'invoicing':
        return <Invoicing />;
      case 'resource-invoicing':
        return <ResourceInvoicing />;
      default:
        return <Invoicing />;
    }
  };

  return (
    <div className="manage-program-container">
      <div className="sidebar">
        <h2>Accounting</h2>
        <ul>
          <li>
            <button
              type="button"
              className={activeSection === 'accounts-receivable' ? 'active' : ''}
              aria-current={activeSection === 'accounts-receivable' ? 'page' : undefined}
              onClick={() => setActiveSection('accounts-receivable')}
            >Accounts Receivable</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'invoicing' ? 'active' : ''}
              aria-current={activeSection === 'invoicing' ? 'page' : undefined}
              onClick={() => setActiveSection('invoicing')}
            >Project Invoicing</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'resource-invoicing' ? 'active' : ''}
              aria-current={activeSection === 'resource-invoicing' ? 'page' : undefined}
              onClick={() => setActiveSection('resource-invoicing')}
            >Resource Invoicing</button>
          </li>
        </ul>
      </div>
      <div className="content-area">
        {renderSection()}
      </div>
    </div>
  );
};

export default Accounting;

